import { render, staticRenderFns } from "./personnelmanagement.vue?vue&type=template&id=bdd34456"
import script from "./personnelmanagement.vue?vue&type=script&lang=js"
export * from "./personnelmanagement.vue?vue&type=script&lang=js"
import style0 from "./personnelmanagement.vue?vue&type=style&index=0&id=bdd34456&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports